import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { HousesPage } from '@/features/houses/houses-page'

export const Route = createFileRoute('/_authenticated/_organization/houses/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: HousesPage,
})
